import { Checkbox } from '@carbon/react';
import type { FilterTemplateProps } from '../../types';
import { useCategoryFields } from '../template-hooks';
import style from '../filter-modal.module.scss';

export const CheckboxTemplate = ({
  category,
  formValues,
  onFormChange,
}: FilterTemplateProps) => {
  const fields = useCategoryFields(category, 'checkbox');

  return (
    <div className={style.fieldStack}>
      {fields.map((field) => (
        <Checkbox
          key={field.id}
          id={`filter-${field.id}`}
          labelText={field.label}
          checked={formValues[field.param] === 'true'}
          onChange={() =>
            onFormChange(
              field.param,
              formValues[field.param] === 'true' ? undefined : 'true'
            )
          }
        />
      ))}
    </div>
  );
};
